import styled from "@emotion/styled";

const GoodOnYouLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  font-weight: ${({ theme }) => theme.fontWeights.body};
  line-height: ${({ theme }) => theme.text.body.source.regular14.lineHeight};
  padding-bottom: ${({ theme }) => theme.space.space16};
  color: ${({ theme }) => theme.colors.tone.anthracite};
  a {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const RateLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space.space8};
`;

export { GoodOnYouLabel, RateLabelWrapper };
